import { Theme } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    minWidth: theme.spacing(12.5),
  },
  menuItemContent: {
    display: 'flex',
    alignItems: 'center',
  },
  logo: {
    height: theme.spacing(3),
    width: theme.spacing(3),
    objectFit: 'contain',
  },
  tooltipTarget: {
    display: 'flex',
    width: '100%',
  },
  disabledMenuItem: {
    '&.Mui-disabled': {
      pointerEvents: 'auto',
      opacity: 0.4,
    },
  },
}))
